/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ButtonEl} from 'common/components/button';

import type {AsyncButton} from './index';

export function template(this: AsyncButton) {
  const content = this.innerHTML.trim();
  return (
    <ButtonEl attrs={this.helpers.getButtonAttrs()} on={{click: this.helpers.handleButtonClick}}>
      {content ? <slot /> : null}
    </ButtonEl>
  );
}
